import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useSpring, useTransform, useReducedMotion } from "framer-motion";

const TravelingDot = () => {
  const reduced = useReducedMotion();
  const ref = useRef(null);
  const [h, setH] = useState(0);
  const [stops, setStops] = useState([]);
  const { scrollYProgress } = useScroll();
  const main = useSpring(scrollYProgress, { stiffness: 110, damping: 17, mass: 0.5 });
  const trailA = useSpring(scrollYProgress, { stiffness: 30, damping: 13, mass: 0.9 });
  const trailB = useSpring(scrollYProgress, { stiffness: 15, damping: 11, mass: 1.2 });
  const y1 = useTransform(main, (v) => 14 + v * (h - 28));
  const y2 = useTransform(trailA, (v) => 14 + v * (h - 28));
  const y3 = useTransform(trailB, (v) => 14 + v * (h - 28));

  useEffect(() => {
    const measure = () => {
      if (ref.current) setH(ref.current.clientHeight);
      const doc = document.documentElement.scrollHeight - window.innerHeight;
      if (doc > 0) {
        setStops(
          Array.from(document.querySelectorAll("[data-chapter]")).map((el) =>
            Math.min(Math.max((el.getBoundingClientRect().top + window.scrollY) / doc, 0), 1),
          ),
        );
      }
    };
    const t = setTimeout(measure, 600);
    window.addEventListener("resize", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, []);

  if (reduced) return null;

  return (
    <div
      ref={ref}
      className="pointer-events-none fixed bottom-10 left-3 top-10 z-40 hidden w-12 lg:block"
      aria-hidden="true"
      data-testid="traveling-dot-track"
    >
      <svg className="h-full w-full" width="48" height={h || "100%"}>
        <defs>
          <filter id="gooey-lava">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
        <line
          x1="24"
          y1="0"
          x2="24"
          y2={h}
          stroke="#4B3428"
          strokeOpacity="0.18"
          strokeWidth="1"
          strokeLinecap="round"
        />
        {stops.map((s, i) => (
          <circle key={i} cx="24" cy={s * h} r="2.5" fill="#4B3428" fillOpacity="0.3" />
        ))}
        <g filter="url(#gooey-lava)">
          <motion.circle cx="24" r="12" fill="#B89A63" style={{ cy: y1 }} data-testid="traveling-dot" />
          <motion.circle cx="24" r="8" fill="#B89A63" style={{ cy: y2 }} />
          <motion.circle cx="24" r="5.5" fill="#B89A63" style={{ cy: y3 }} />
        </g>
      </svg>
    </div>
  );
};

export default TravelingDot;
